var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwerve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.484,
    height: 20.835,
    viewBox: "0 0 20.484 20.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e117f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfb6fd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6554",
    "data-name": "Group 6554",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8062",
    "data-name": "Path 8062",
    d: "M-11985.184-8177.92s-1.809,1.28-1.656,2.3,1.455,1.992,1.021,2.748a15.56,15.56,0,0,1-1.5,1.922h4.352s.664-.363.633-1.7-1.627-2.239-1.215-2.966,1.215-2.3,1.215-2.3Z",
    transform: "translate(11987.314 8191.783)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8063",
    "data-name": "Path 8063",
    d: "M-11985.184-8177.92s-1.809,1.28-1.656,2.3,1.455,1.992,1.021,2.748a15.56,15.56,0,0,1-1.5,1.922h4.352s.664-.363.633-1.7-1.627-2.239-1.215-2.966,1.215-2.3,1.215-2.3Z",
    transform: "translate(12001.228 8191.783)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car",
    "data-name": "Icon awesome-car",
    d: "M19.578,8.886H17.234l-.652-1.629A4.363,4.363,0,0,0,12.511,4.5H7.538A4.365,4.365,0,0,0,3.466,7.257L2.814,8.886H.47a.47.47,0,0,0-.456.584l.235.94a.47.47,0,0,0,.456.356h.786a2.489,2.489,0,0,0-.865,1.88v1.88a2.486,2.486,0,0,0,.627,1.642v2.117a1.253,1.253,0,0,0,1.253,1.253H3.759a1.253,1.253,0,0,0,1.253-1.253V17.03H15.037v1.253a1.253,1.253,0,0,0,1.253,1.253h1.253A1.253,1.253,0,0,0,18.8,18.283V16.166a2.484,2.484,0,0,0,.627-1.642v-1.88a2.49,2.49,0,0,0-.864-1.88h.786a.47.47,0,0,0,.456-.356l.235-.94a.47.47,0,0,0-.456-.584Zm-13.786-.7A1.88,1.88,0,0,1,7.538,7.006h4.973a1.88,1.88,0,0,1,1.745,1.181l.78,1.951H5.012l.78-1.951ZM3.759,14.516a1.182,1.182,0,0,1-1.253-1.249,1.182,1.182,0,0,1,1.253-1.249,2.411,2.411,0,0,1,1.88,1.874C5.639,14.641,4.511,14.516,3.759,14.516Zm12.53,0c-.752,0-1.88.125-1.88-.625a2.411,2.411,0,0,1,1.88-1.874,1.182,1.182,0,0,1,1.253,1.249,1.182,1.182,0,0,1-1.253,1.249Z",
    transform: "translate(0.435 -4.5)",
    fill: "#2e117f"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwerve);
export default __webpack_public_path__ + "static/media/swerve.28a446b31df3e770d82c425fb92c5792.svg";
export { ForwardRef as ReactComponent };